import {OptionType} from './types';

export const simpleOptionMapper = (simpleOptions: string[]): OptionType[] =>
  simpleOptions.map(simpleOption => ({
    value: simpleOption,
    text: simpleOption,
  }));
